
import { defineMessages } from 'react-intl'

export default defineMessages({
    firstName: {
        defaultMessage: 'Nombre',
    },
    lastName: {
        defaultMessage: 'Apellido',
    },
    email: {
        defaultMessage: 'Email',
    },
    firstNamePlaceholder: {
        defaultMessage: 'Ejemplo: Juan',
    },
    lastNamePlaceholder: {
        defaultMessage: 'Ejemplo: Rodríguez López',
    },
    emailPlaceholder: {
        defaultMessage: 'Ej.: email@email.com',
    },
    phone: {
        defaultMessage: 'Teléfono',
    },
    cardNumberRequiredError: {
        defaultMessage: 'El número de tarjeta está incompleto.',
    },
    cardNumberCompleteError: {
        defaultMessage: 'No es un número de tarjeta válido.',
    },
    cardNumberLabel: {
        defaultMessage: 'Número de tarjeta',
    },
    cardExpiryRequiredError: {
        defaultMessage: 'Fecha de validez incompleta.',
    },
    cardExpiryCompleteError: {
        defaultMessage: 'La fecha no es válida.',
    },
    cardExpiryLabel: {
        defaultMessage: 'Fecha de caducidad',
    },
    cardCVCRequiredError: {
        defaultMessage: 'El CVC está incompleto.',
    },
    cardCVCCompleteError: {
        defaultMessage: 'El CVC está incompleto.',
    },
    cardCVCLabel: {
        defaultMessage: 'CVC',
    },
})
